import ReactECharts from "echarts-for-react";
import { Weather } from '../../../../types/variables/Variables';
import { returnChartColor } from '../../../../utils/charts/colors';

const Temperature = ({ weather }: { weather: Weather }) => {
    const option = {
        color: [returnChartColor(weather)[1]],
        xAxis: {
            show: false,
            type: 'category',
            boundaryGap: false,
            data: ['Mon', 'Tue', 'Wed']
        },
        yAxis: {
            show: false,
            boundaryGap: false,
            type: 'value',
        },
        grid: {
            top: '0%',
            left: '0%',
            right: '0%',
            bottom: '0%',
            containLabel: false,
        },
        series: [
            {
                data: [12, 13, 13],
                type: 'line',
                lineStyle: {
                    width: 2,
                    color: returnChartColor(weather)[1],
                },
                areaStyle: {},
                symbolSize: 0,
                smooth: true,

            }
        ]
    }

    return <ReactECharts option={option} style={{ height: 100, width: 270 }} />
};

export { Temperature };